import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  ApplyVisitMutation as ApplyVisitMutationType,
  ApplyVisitMutationVariables,
} from "./__generated__/ApplyVisitMutation";

const ApplyVisitMutation = loader("./ApplyVisitMutation.gql");

type ApplyVisitMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: ApplyVisitMutationType) => void;
}) => ReactElement;

export const ApplyVisitMutationProvider: ApplyVisitMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<ApplyVisitMutationType, ApplyVisitMutationVariables>(ApplyVisitMutation, {
    errorPolicy: "none",
    onError,
    onCompleted,
  });

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
